<div class="m-section">
	<div class="m-section__content">
		<table class="notranslate table table-striped m-table" *ngIf="tabledHeaderBody">
			<thead>
				<tr>
					<th *ngFor="let header of tabledHeaderBody.header">{{header}}</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let element of tabledHeaderBody.data; let i = index;">
					<td>{{i + 1}}</td>
					<td *ngFor="let key of tabledHeaderBody.keys; let j = index;">
						{{(findDataType(element[key]) === 'object')? element[key].length : element[key]}}
						<span *ngIf="j === (tabledHeaderBody.keys.length-1)" style="overflow: visible; width: 110px;">
							<div class="dropdown">
								<a href="javascript:;" class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown">
									<i class="la la-ellipsis-h"></i>
								</a>
								<div class="dropdown-menu dropdown-menu-right">
									<a *ngFor="let action of tabledHeaderBody.keys[tabledHeaderBody.keys.length - 1]" class="dropdown-item" href="javascript:;"
									 (click)="onActionClick(action, i)">{{action}}</a>
								</div>
							</div>
						</span>
					</td>
				</tr>
			</tbody>
		</table>
		<!-- <app-pagination [count]="pagination.count" (pageNumber)="paginationByPageNo($event)" (recordsPerPage)="recordsforPage($event)"></app-pagination> -->
	</div>
</div>